export const homepageParallax = function() {
	const parallaxContainers = document.querySelectorAll('.homepage-carousel__parallax-container'),
		  firstLayerImages = document.querySelectorAll('.homepage-carousel__parallax-opacity');
	if (!parallaxContainers) return;
	[].slice.call(parallaxContainers).forEach(container => {
		const parallaxInstance = new Parallax(container, {
			hoverOnly: true
		});
	});
	setTimeout(_=> {
		[].slice.call(firstLayerImages).forEach(layer => {
			layer.style.display = 'none';
		});
	}, 500);
}
